<template>
    <div>
        <!-- 右边弹框 -->
        <van-popup v-model="langShow" position="right">
            <div class="main-box">
                <div class="box">
                    <div class="title-box">
                        <h2>{{ $t('yuyan') }}</h2>
                        <button type="button" class="btn" @click="langShow = false">
                            <i class="iconfont icon-guanbi"></i>
                        </button>
                    </div>
                    <div class="uls">
                        <div class="t-box">
                            <div class="li" @click.stop="showLangStatus = !showLangStatus">
                                <div class="logos">
                                    <img :src="require(`../../assets/images/langLogo/${lang}.png`)" alt="">
                                </div>
                                <div class="t-text">
                                    {{ lang_list[lang] }}
                                </div>
                                <div class="icon" :class="{ 'xz': showLangStatus }">
                                    <i class="iconfont icon-xiajiantou"></i>
                                </div>
                            </div>
                            <div class="boxs" v-if="showLangStatus">
                                <a class="lis" :class="{ 'active-li': lang === key }" v-for="(item, key) in lang_list"
                                    :key="key" @click="changeLang(key)">
                                    <img :src="require(`../../assets/images/langLogo/${key}.png`)" alt="">
                                    <span>{{ item }}</span>
                                </a>
                            </div>
                        </div>
                        <div style="height: 50px;"></div>
                    </div>
                </div>
            </div>
        </van-popup>
        <img src="@/assets/images/bg1.jpg" class="bgImg" alt="">
        <div class="basic_wrap">
            <div class="login_bg">
                <!-- <div class="back_left" @click="$router.push('/index')"></div> -->
                <!-- <div class="big_tit">{{ $t('login.login') }}</div> -->
                <div class="language" @click="toKefuLink">
                    <span class="iconfont icon-kefu3"></span>
                </div>
                <div class="language" @click="langShow = true">
                    <span class="iconfont icon-yuyan1"></span>
                </div>
                <div style="width: 15px;"></div>
                <!-- <div class="languages" @click="$router.push('/register')">
                    <span> {{ $t('login.signUp') }} </span>
                </div> -->
            </div>
            <div class="kefus">
               {{ $t('Sign') }}
            </div>
            <form class="form">
                <div class="cut_login">
                    <a :class="{'cur':login_type === 0}" @click="changeFun(0)">
                        <span>{{ $t('sj') }}</span>
                        <div class="line" v-if="login_type === 0"></div>
                    </a>
<!--                    <a :class="{'cur':login_type === 1}" @click="changeFun(1)">-->
<!--                        <span>{{ $t('email') }}</span>-->
<!--                        <div class="line" v-if="login_type === 1"></div>-->
<!--                    </a>-->
                </div>
                <div class="item mt" v-if="login_type === 0">
                    <span class="icon">
                        <img src="../images/login/tel.png" alt="" />
                    </span>
                    <a class="text-phone" @click.stop="countryShow = !countryShow">
                        {{ data.country }}
                    </a>
                    <input type="text" class="inp" v-model.trim="data.username"
                        :placeholder="$t('setpaypwd.pureNumber')" />
                    <div class="item_box" v-if="countryShow">
                        <div class="search-box">
                            <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')" @input="inputFun"></input>
                        </div>
                        <a v-for="(item, index) in countrys" :key="index" :class="{ 'active': item.code === data.country }"
                            @click.stop="onSelect(item)">
                            <img :src="require(`../../assets/images/flags/${item.code.toLowerCase()}.png`)" alt="">
                            <span>+{{ item.dial_code }} {{ item.name }}</span>
                        </a>
                    </div>
                </div>
                <div class="item mt" v-if="login_type === 1">
                    <span class="icon">
                        <img src="../images/login/email.png" alt="" />
                    </span>
                    <input type="text" class="inp" v-model.trim="data.username"
                        :placeholder="$t('login.phoneNumber')" />
                </div>
                <div class="item">
                    <span class="icon"><img src="../images/login/lock.png" alt="" /></span>
                    <input :type="password" class="inp" v-model.trim="data.password"
                        :placeholder="$t('login.password')" />
                    <div class="eye_bi" @click="showPwd" :class="password == 'text' ? 'eye' : ''"></div>
                </div>
                <div class="item_reset_pwd">
                    <van-checkbox v-model="checked" icon-size="14px" shape="square">{{ $t('login.remember') }}</van-checkbox>
                    <!-- <router-link class="reset_pwd" to="/forgetpwd">{{ $t('login.forget') }}</router-link> -->
                </div>
            </form>
            <div type="submit" class="basic_btn sbtn" :class="data.username == '' || data.password == '' ? 'no_touch' : ''" @click="submit">
                {{ $t('Sign') }}
            </div>
            <div type="submit" class="basic_btn sbtn" style="margin-top: 10px;background: none;color:#01EDC2 !important;text-decoration: underline;" @click="$router.push('/register')">
                {{ $t('login.signUp') }}
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import {lang_list,lang} from '@/locale/index'
import { CountDown, Checkbox, Toast } from 'vant'
import countryListRaw from '../country-data.js'
Vue.use(Checkbox)

export default {
    name: "login",
    data() {
        return {
            langShow:false,
            login_type:0,
            countryShow: false,
            countrys: [],
            countrys2:[],
            lang: this.$i18n.locale || lang,
            lang_list: lang_list,
            password: "password",
            show_kefu: false,
            msg_show: true,
            checked: true,
            checkeds: false,
            data: {
                username: "",
                password: "",
                country: localStorage.getItem('countryCode') || "+55"
            },
            logo: '',
            kefu_link:'',
            showLangStatus:false,
            searchCode:''
        };
    },
    created() {
        this.data.username = localStorage.getItem('login_username');
        this.data.password = localStorage.getItem('login_password');
        this.$parent.footer("user", false);
        Fetch("/index/webconfig").then((r) => {
            this.logo = r.data.logo
            this.kefu_link = r.data.kefu_link
            localStorage.setItem('logo', r.data.logo)
        });
        this.countrys = countryListRaw
        this.countrys2 = countryListRaw
    },
    mounted() {
        var that = this;
        document.body.addEventListener(
            "scroll",
            function () {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function (ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
    },
    methods: {
        inputFun() {
            // 如果输入框为空，恢复原始数据
            if (!this.searchCode) {
                this.countrys = [...this.countrys2];
                return;
            }

            // 筛选逻辑：匹配区号中的数字部分
            const searchValue = this.searchCode;
            this.countrys = this.countrys2.filter(item => {
                // 去除code中的+号，只保留数字进行匹配
                const codeNumber = item.dial_code.replace('+', '');
                // 包含匹配（也可以改成开头匹配：codeNumber.startsWith(searchValue)）
                return codeNumber.includes(searchValue);
            });
        },
        changeFun(type) {
            this.login_type = type
        },
        toKefuLink() {
            window.location.href = this.kefu_link
        },
        onSelect(action) {
            this.data.country = '+'+action.dial_code
            this.countryShow = false
        },
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push("/kefu");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        changeLang(lang, event) {
            Toast.loading({
                // mask: true,
                duration: 200
            })
            this.lang = lang;
            this.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
            window.location.reload()
        },
        submit() {
            let that = this;
            // if (!this.checkeds) {
            //     this.$toast(this.$t('qyexy'));
            //     return;
            // }
            if (!this.data.username) {
                this.$toast(this.$t('setpaypwd.pureNumber'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }

            if (this.checked) {
                localStorage.setItem('login_username', this.data.username);
                localStorage.setItem('login_password', this.data.password);
            }

            if (!this.checked) {
                localStorage.removeItem('login_username');
                localStorage.removeItem('login_password');
            }

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password,
                country: this.data.country,
                status:this.login_type === 0 ? 1 : 0
            }).then((res) => {
                // console.log(res,'res')
                if (res.data && res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('countryCode', that.data.country)
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                    setTimeout(() => {
                        this.$router.push('/index')
                    }, 500);
                } else {
                    Toast(res.msg)
                }
            })
        },
    },
};
</script>

<style lang="less" scoped>
.logo-wrap {
    height: 100px;
}

.login_bg {
    width: 100%;
    height: 50px;
    overflow: hidden;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .language {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
            font-size: 22px;
            color:#01EDC2;
        }
    }
    .languages {
        width: fit-content;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px 0px 10px;
        span {
            font-size: 14px;
            color: #01EDC2;
            --tw-text-opacity:1;
            text-decoration-line: underline;
        }
    }
}
.language img {
    height: 100%;
    width: auto;
}

.text-phone {
    display: flex;
    cursor: pointer;
    padding-right: 15px;
    padding-bottom: 0px;
    line-height: 28px;
    background-image: url(~@/assets/images/xjt.png);
    background-repeat: no-repeat;
    background-size: 12px 12px;
    background-position: right center;
}

.basic_wrap {
    width: 100%;
    height: 100vh;
    max-width: 750px;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    z-index: 10;
    padding-top: 30px;
    background: rgba(0, 0, 0, 0.5);
    // background: url('~@/assets/images/bg1.jpg') no-repeat center center / cover;
}

.basic_wrap .form {
    margin:30px auto;
    width: 90%;
    height: fit-content;
    border-radius: 13px;
    padding: 0px;
}
.big_tit {
  color: #fff !important;
}
.cut_login {
    width: fit-content;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;

    a {
        width: 50%;
        padding-bottom: 5px;
        color: #809391;
        position: relative;
        white-space: nowrap;
        margin-right: 20px;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #01EDC2;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #01EDC2, #01EDC2);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 52px;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 0 10px;

    .item_box {
        width: 100%;
        height: 320px;
        overflow-y: scroll;
        position: absolute;
        left: 0px;
        top: 52px;
        background: #fff;
        box-shadow: 0 0 3px #999;
        border-radius: 10px;
        padding: 10px 10px 0px 10px;
        z-index: 10;
        .search-box {
            height: 40px;
            width: 100%;
            background: #eee;
            border-radius: 8px;
            margin-bottom: 10px;
            padding: 0 10px;
            box-sizing: border-box;
            input {
                width: 100%;
                height: 100%;
                font-size: 14px;
            }
        }
        a {
            display: block;
            width: 100%;
            height: 38px;
            border-bottom: 1px solid #eee;
            line-height: 38px;
            padding: 0 8px;
            cursor: pointer;
            display: flex;
            align-items: center;
            img {
                display: block;
                width: 32px;
                height: 20px;
                margin-right: 10px;
                border: 1px solid #eee;
            }
        }

        .active {
            background: #eee;
        }
    }

    .icon {
        width: auto;
        height: 20px;

        img {
            display: block;
            width: auto;
            height: 100%;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.flexs {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;

    .van-checkbox {
        margin-top: 0px;
        margin-left: 5px;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: #3d96ff;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}

.van-checkbox {
    margin-top: 20px;
}

.reset_pwd {
    color: #3d96ff;
    margin-top: -20px;
    display: block;
}

.basic_btn {
    margin: 112px auto 0 auto;
}
.basic_btn:active,.basic_btn:hover {
    background: rgba(74,230,174,0.5);
}

.text-phone {
    width: fit-content;
    display: flex;
    align-items: center;
}
::v-deep .van-checkbox__label {
    color: #ffffff;
    font-size: 12px;
}
.main-box {
    width: 100vw;
    max-width: 520px;
    height: 100dvh;
    position: relative;
    background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);
    .box {
        width: 100%;
        height: 100%;
        position: relative;
        background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            h2 {
                color: #fff;
            }

            .btn {
                border: 1px solid #2D4B44;
                border-radius: 15px;
                padding: 6px 9px;
                color: #fff;

                .iconfont {
                    font-size: 18px;
                }
            }
        }

        .uls {
            width: 100%;
            height: 100%;
            margin-top: 20px;
            display: flex;
            flex-direction: column;

            .t {
                color: #ffffffa6;
                font-size: 11px;
                text-transform: uppercase;
            }

            .hr {
                margin-top: auto;
                width: 100%;
                height: 2px;
                background: #476052;
                margin-top: auto;
            }

            .t-box {
                width: 100%;
                height: fit-content;
                margin-top: 10px;
                padding: 12px;
                border-radius: 15px;
                border: 1.5px solid #518b80;
                background: #245547;
                background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, rgba(43, 68, 47, 1) 100%);
                display: flex;
                align-items: center;
                position: relative;

                .li {
                    width: 100%;
                    height: fit-content;
                    display: flex;
                    border: 1px solid #4e8886;
                    border-radius: 15px;
                    padding: 12px;
                    align-items: center;
                    background: rgba(32, 67, 62, 0.5);

                    .logos {
                        width: fit-content;
                        height: 18px;
                        border: 1px solid #4D6D69;
                        border-radius: 10px;
                        margin-right: 10px;

                        img {
                            display: block;
                            width: auto;
                            height: 100%;
                        }
                    }

                    .t-text {
                        font-size: 14px;
                        font-weight: bold;
                        color: #ffffff;
                    }

                    .icon {
                        .iconfont {
                            font-size: 22px;
                        }
                    }
                }

                .boxs {
                    position: relative;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    top: 60px;
                    z-index: 99;
                    border-radius: 20px;
                    background: #245547;
                    background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, #051A15 100%);
                    overflow: hidden;
                    overflow-y: scroll;
                    padding: 12px;
                    border: 1px solid #4e8886;

                    .lis {
                        width: 100%;
                        display: flex;
                        background: rgba(18, 46, 41, 0.3);
                        border-radius: 10px;
                        margin-bottom: 10px;
                        display: flex;
                        align-items: center;
                        padding: 15px;
                        border: 1px solid #4e8886;

                        img {
                            display: block;
                            width: auto;
                            height: 16px;
                            margin-right: 10px;
                        }

                        span {
                            color: #fff;
                            font-size: 14px
                        }
                    }
                }

                .icon {
                    margin-left: auto;
                    transition: 0.3s;

                    .iconfont {
                        font-size: 14px;
                        color: #758678;
                    }
                }

                .logo {
                    padding: 7px;
                    border-radius: 10px;
                    margin-right: 10px;
                    border: 1px solid #4A726A;

                    .iconfont {
                        color: #ffffff;
                        font-size: 20px;
                    }
                }

                .t-boxs {
                    color: #ffffff;

                    .t1 {
                        font-size: 15px;
                    }

                    .t2 {
                        font-size: 12px;
                        margin-top: 8px;
                    }
                }

                .boxs {
                    width: 325px;
                    height: fit-content;
                    max-height: 256px;
                    overflow: hidden;

                    .active-li {
                        background: rgba(43, 61, 34, 0.8) !important;
                    }
                }
            }
        }
    }
}

</style>
